// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.roninchain.wallet",
    name: "Ronin Wallet",
    homepage: "https://wallet.roninchain.com/",
    image_id: "bd78de7e-36da-4552-ebdd-2e420ba05900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/ronin-wallet/id1592675001",
        android: "https://play.google.com/store/apps/details?id=com.skymavis.genesis",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/ronin-wallet/fnjhmkhhmkbjkkabndcnnogagogbneec",
        firefox: "https://addons.mozilla.org/firefox/addon/ronin-wallet/",
        safari: null,
        edge: "https://microsoftedge.microsoft.com/addons/detail/ronin-wallet/kjmoohlgokccodicjjfebfomlbljgfhk",
        opera: null,
    },
    rdns: "com.roninchain.wallet",
    mobile: {
        native: "roninwallet://",
        universal: "https://wallet.roninchain.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map